import React, { useContext, useState } from 'react'

const RecordLockContext = React.createContext()
export const useRecordLock = () => useContext(RecordLockContext)

export const RecordLockProvidor = ({ children }) => {
  const [recordLock, setRecordLock] = useState(true)

  return (
    <RecordLockContext.Provider value={{ recordLock, setRecordLock }}>
      {children}
    </RecordLockContext.Provider>
  )
}
